import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RedirectAuth = () => {
  const { isAdmin, isLoading } = useAuth();
  
  // Aguardar carregamento
  if (isLoading) {
    return null;
  }
  
  // Redireciona admin para dashboard, usuário para dashboard de créditos
  if (isAdmin()) {
    return <Navigate to="/dashboard/configuracoes" replace />;
  }
  
  return <Navigate to="/dashboard/creditos" replace />;
};

export default RedirectAuth;

